import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Invoice\GetItemsDossierController::__invoke
* @see app/Http/Controllers/Invoice/GetItemsDossierController.php
* @route '/api/invoicing/{invoice}/dossier-items'
*/
const GetItemsDossierController = (args: { invoice: string | number | { id: string | number } } | [invoice: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetItemsDossierController.url(args, options),
    method: 'get',
})

GetItemsDossierController.definition = {
    methods: ["get","head"],
    url: '/api/invoicing/{invoice}/dossier-items',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Invoice\GetItemsDossierController::__invoke
* @see app/Http/Controllers/Invoice/GetItemsDossierController.php
* @route '/api/invoicing/{invoice}/dossier-items'
*/
GetItemsDossierController.url = (args: { invoice: string | number | { id: string | number } } | [invoice: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { invoice: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { invoice: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            invoice: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        invoice: typeof args.invoice === 'object'
        ? args.invoice.id
        : args.invoice,
    }

    return GetItemsDossierController.definition.url
            .replace('{invoice}', parsedArgs.invoice.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Invoice\GetItemsDossierController::__invoke
* @see app/Http/Controllers/Invoice/GetItemsDossierController.php
* @route '/api/invoicing/{invoice}/dossier-items'
*/
GetItemsDossierController.get = (args: { invoice: string | number | { id: string | number } } | [invoice: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetItemsDossierController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Invoice\GetItemsDossierController::__invoke
* @see app/Http/Controllers/Invoice/GetItemsDossierController.php
* @route '/api/invoicing/{invoice}/dossier-items'
*/
GetItemsDossierController.head = (args: { invoice: string | number | { id: string | number } } | [invoice: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetItemsDossierController.url(args, options),
    method: 'head',
})

export default GetItemsDossierController